// extracted by mini-css-extract-plugin
export default {"Mcontainer":"Mcontainer__fl1xn"};